module.exports = __webpack_public_path__ + "img/fabu.d65b0ec1.png";